export const animateBackground = (
  tl: gsap.core.Timeline,
  lightLayer: HTMLElement,
  darkLayer: HTMLElement,
  nextTheme: 'light' | 'dark',
) => {
  tl.to(
    lightLayer,
    {
      opacity: nextTheme === 'light' ? 1 : 0,
      duration: 0.8,
      ease: 'power2.inOut',
    },
    0,
  ).to(
    darkLayer,
    {
      opacity: nextTheme === 'dark' ? 1 : 0,
      duration: 0.8,
      ease: 'power2.inOut',
    },
    0,
  );
};
